import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { useTranslation } from '@/contexts/TranslationContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PartnerMarquee = () => {
  const [partners, setPartners] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const response = await axios.get(`${API}/partners`);
        setPartners(response.data);
      } catch (error) {
        console.error('Error fetching partners:', error);
      }
    };
    fetchPartners();
  }, []);

  // Duplicate partners 3 times for seamless infinite scroll
  const allPartners = [...partners, ...partners, ...partners];

  return (
    <div className="py-16 bg-gray-50 border-y border-gray-200 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8">
        <p className="text-sm font-semibold text-gray-500 tracking-wider uppercase font-['Manrope']">
          {t('partners.title')}
        </p>
      </div>

      <div className="relative">
        <motion.div
          animate={{ x: ["-33.33%", "-66.66%"] }}
          transition={{
            duration: 30,
            repeat: Infinity,
            ease: "linear"
          }}
          className="flex gap-12 items-center"
        >
          {allPartners.map((partner, index) => (
            <div
              key={`${partner.id}-${index}`}
              className="flex-shrink-0 px-8 grayscale hover:grayscale-0 transition-all duration-300"
            >
              <img
                src={partner.logo_url}
                alt={partner.name}
                className="h-16 w-auto object-contain opacity-70 hover:opacity-100 transition-opacity"
              />
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default PartnerMarquee;
